export const ConstantsUtil = {
    WC_NAME_SUFFIX: '.wcn.id',
    WC_NAMES_ALLOWED_DOMAINS: ['walletconnect.com']
};
//# sourceMappingURL=ConstantsUtil.js.map